import { JL } from 'jsnlog'
import $config from '@/config'
import _ from 'lodash'
import store from '@/store'

var logger = JL();
var appender = JL.createAjaxAppender("event");

let appendUserData = async function(xhr, json){ 
  let user = null;
  let device = null;

  if(_.has(store.state,'registrations.copy')){
    user = store.state.registrations.copy
  }
  if(_.has(store.state,'devices.copy')){
    device = store.state.devices.copy
  }

  await _.forEach(json.lg, (lg)=>{
    lg['userAgent']=navigator.userAgent
    lg['device']=device
    lg['user']=user
  }); 

  return true;
}

appender.setOptions({
  "url": $config.feathersServer+"/eventpagelogs",
  "beforeSend": appendUserData
});

logger.setOptions({
  appenders: [appender]
})

export default logger;